// @ts-nocheck
import { App } from "vue";

export const components = (vue: App<Element>) => {
  vue.component("AuthCompletion", () =>
    import(`@/assets/svg/AuthCompletion.svg?components`)
  );
  vue.component("Balloon", () => import(`@/assets/svg/Balloon.svg?components`));
  vue.component("ExchangeCompletion", () =>
    import(`@/assets/svg/ExchangeCompletion.svg?components`)
  );
  vue.component("Flowers", () => import(`@/assets/svg/Flowers.svg?components`));
  vue.component("NoSalary", () =>
    import(`@/assets/svg/NoSalary.svg?components`)
  );
  vue.component("Favorite", () =>
    import("@/assets/svg/Favorite.svg?component")
  );
  vue.component("LimitedReleaseFlag", () =>
    import("@/assets/svg/LimitedReleaseFlag.svg?component")
  );
  vue.component("BeginnerMark", () =>
    import("@/assets/svg/BeginnerMark.svg?component")
  );
};
